import { useContext } from "react";
import { GlobalContext, GlobalContextType } from "./GlobalContextProvider";

export function useDecorationTechContext() {
  const { decorTechs } = useContext<GlobalContextType>(GlobalContext);
  return decorTechs;
}
